import FieldProject from "../../../generic/entity/project/project"
import FieldConfig from "../../../../fields3/proto/field-config"
import {EntityType} from "../../../../gd/const/item";

export default class FieldRequestFormParent extends FieldProject {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel      = "Parent"

        this.label          = 'Project'

        this.noValueOption  = false
        this.parentsFor     = _.get(config,'parentsFor', EntityType.FORM)
    }
}
